/**
 * @generated SignedSource<<42823b3ee467d8f22115aadc23e6c129>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutNeedsToAcknowledgeRestrictions_transaction$data = {
  readonly warnings: {
    readonly hasRestrictedMaterials: boolean | null;
    readonly isCheckoutBlocked: boolean | null;
  } | null;
  readonly " $fragmentType": "CheckoutNeedsToAcknowledgeRestrictions_transaction";
};
export type CheckoutNeedsToAcknowledgeRestrictions_transaction$key = {
  readonly " $data"?: CheckoutNeedsToAcknowledgeRestrictions_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutNeedsToAcknowledgeRestrictions_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutNeedsToAcknowledgeRestrictions_transaction",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "countryCode",
          "variableName": "userCountryCode"
        }
      ],
      "concreteType": "TransactionWarningQueryType",
      "kind": "LinkedField",
      "name": "warnings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCheckoutBlocked",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasRestrictedMaterials",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "c00ef97c5c34994a9103f52ee7570560";

export default node;
